module.exports = __webpack_public_path__ + "img/arrow_right_circle.475d0fae.svg";